import { Video } from "lucide-react";

export const WEBINARS = [
  ["Ripartire", "fare spazio al nuovo", "a lasciare andare ciò che ti appesantisce e a scegliere da dove ricominciare."],
  ["Costanza", "quando la motivazione finisce", "a mantenere le tue abitudini anche nei giorni senza voglia, con passi piccoli che reggono."],
  ["Energia", "proteggere ciò che ti ricarica", "a riconoscere cosa ti scarica e a difendere i momenti che ti danno energia."],
  ["Mentalità", "da critico interiore ad alleato", "a trasformare la voce che ti critica in una voce che ti sostiene."],
];

export function WebinarList({ className = "" }) {
  return (
    <div className={`rounded-2xl border border-[#D4AF37]/50 bg-[#D4AF37]/[0.08] p-4 ${className}`} data-testid="webinar-list-static">
      <div className="flex items-start justify-between gap-3">
        <p className="flex items-center gap-2 text-base font-semibold text-[#E5C158]"><Video size={18} className="shrink-0" /> 4 webinar in video con Mino Cesari</p>
        <span className="shrink-0 rounded-full bg-[#D4AF37] px-2.5 py-0.5 text-[11px] font-bold uppercase text-[#09090B]" data-testid="webinar-value-badge">Valore €80</span>
      </div>
      <p className="mt-1 text-sm text-[#B4B4BC]">Inclusi nel piano annuale · 90 minuti, uno ogni tre mesi</p>
      <ol className="mt-3 space-y-3">
        {WEBINARS.map(([t, s, learn], i) => (
          <li key={t} className="flex gap-3">
            <span className="font-serif-el w-4 shrink-0 text-lg font-semibold leading-6 text-[#D4AF37]">{i + 1}</span>
            <div className="text-sm leading-snug">
              <p className="text-[#D4D4D8]"><b className="text-[#FAF9F6]">{t}:</b> {s}</p>
              <p className="mt-0.5 text-[#A1A1AA]"><span className="text-[#E5C158]">Cosa imparerai:</span> {learn}</p>
            </div>
          </li>
        ))}
      </ol>
      <p className="mt-3 border-t border-[#D4AF37]/20 pt-3 text-[13px] text-[#A1A1AA]">Non puoi partecipare nella data programmata? Ricevi la registrazione nel tuo account.</p>
    </div>
  );
}

export function ValueMath({ className = "" }) {
  const rows = [["12 mesi a €7,99", "€95,88"], ["4 webinar in video", "€80,00"]];
  return (
    <div className={`rounded-2xl border border-[#27272A] bg-[#0D0D0F] p-4 text-sm ${className}`} data-testid="annual-value-math">
      {rows.map(([l, v]) => (
        <p key={l} className="flex justify-between text-[#B4B4BC]"><span>{l}</span><span>{v}</span></p>
      ))}
      <p className="mt-1.5 flex justify-between border-t border-[#27272A] pt-1.5 text-[#B4B4BC]"><span>Valore totale</span><span className="line-through">€175,88</span></p>
      <p className="mt-1 flex items-baseline justify-between font-semibold text-[#FAF9F6]"><span>Tu paghi</span><span className="font-serif-el text-2xl text-[#E5C158]">€49,99</span></p>
    </div>
  );
}

export function WebinarBonus() {
  return (
    <div className="mt-4 space-y-3" data-testid="webinar-bonus">
      <WebinarList />
      <ValueMath />
    </div>
  );
}
